import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Card,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  IconButton,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Iconify from '../../../components/iconify';

import { API_BASE_URL } from '../../../utils/env';

export default function Settings() {
  const { userInfo } = useSelector((state) => state.auth);
  // Decode JWT token to get user information
  const decodedToken = jwtDecode(userInfo.token);
  // Extract the 'id' from the decoded token

  const parishId = decodedToken.parishId;
  const [otherPreferenceList, setOtherPreferenceList] = useState([]);
  const [departmentPreferenceList, setDepartmentPreferenceList] = useState([]);
  const [parishData, setParishData] = useState([]);
  const [status, setStatus] = useState(false);
  const [status2, setStatus2] = useState(false);
  const [status3, setStatus3] = useState(false);
  const [preferenceLoading, setPreferenceLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openDep, setOpenDep] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');

  const [selectedTab, setSelectedTab] = useState(0);

  const [memberTypeId, setMemberTypeId] = useState('');
  const [deleteMemberTypeLoading, setDeleteMemberTypeLoading] = useState(false);

  const [deleteDepartmentLoading, setDeleteDepartmentLoading] = useState(false);
  const [departmentPreferenceId, setDepartmentPreferenceId] = useState('');

  const [loading, setLoading] = useState(false)

  // token to parsed in headers
  const token = userInfo.token;

  // State for all input fields
  const [formData, setFormData] = useState({
    parishId: `${parishId}`,
    value: '',
  });
  const [name, setName] = useState('');


  // Generic onChange handler
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    const apiUrl = `${API_BASE_URL}/Parish/UpdateParishDetails`;
    const token = userInfo.token;

    const payload = {
      parishId,
      parishPhoneNumber: parishData.parishPhoneNumber,
      pastorName: parishData.pastorName,
      address: parishData.address,
    };

    try {
      const response = await axios.put(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json', // Explicitly set JSON content type
        },
      });

      if (response.data.success) {
        // setParishData(response.data);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error updating parish details:', error);
      toast.error('An error occurred while updating parish details.');
    } finally {
      setLoading(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };



  const handleOpenMenu = (event, id) => {
    setOpen(event.currentTarget);
    setMemberTypeId(id);
  };

  const handleOpenDepMenu = (event, id) => {
    setOpenDep(event.currentTarget);
    setDepartmentPreferenceId(id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setMemberTypeId('');
  };

  const handleCloseDepMenu = () => {
    setOpenDep(null);
    setDepartmentPreferenceId('');
  };

  const handleOpenDialog = () => {
    setOpenDialog(true); // Open the dialog when the button is clicked
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Close the dialog when user cancels
  };

  const handleSavePreference = async () => {
    setPreferenceLoading(true);

    let endpoint;

    if (selectedValue === 'Member Type') {
      const preferences = new FormData();
      preferences.append('name', formData.value);
      preferences.append('ParishId', formData.parishId);
      endpoint = `${API_BASE_URL}/Member/AddMemberTypeByParish`;

      try {
        // Proceed with form submission
        const response = await axios.post(endpoint, preferences, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

        setOtherPreferenceList((prevData) => {
          // Use unshift to add the new preference at the beginning of the array
          prevData.unshift(response.data);
          return prevData;
        });

        setPreferenceLoading(false);
        toast.success('Preferences added successfully');
        handleCloseDialog();

        // reset the field values
        setSelectedValue('');
        formData.value = '';
      } catch (error) {
        setPreferenceLoading(false);
        toast.error(`${error.response?.data?.message || 'Error adding preference'}`);
        console.error('Error adding preference:', error.response?.data?.message || error.message);
      }
    } else if (selectedValue === 'Department') {
      const preferences = new FormData();
      preferences.append('DepartmentName', formData.value);
      preferences.append('ParishId', formData.parishId);
      endpoint = `${API_BASE_URL}/Parish/AddDepartmentByParish`;

      try {
        // Proceed with form submission
        const response = await axios.post(endpoint, preferences, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data', // Adjust the content type if needed
          },
        });
        handleCloseDialog();

        setDepartmentPreferenceList((prevData) => {
          // Use unshift to add the new preference at the beginning of the array
          prevData.unshift(response.data);
          return prevData;
        });

        setPreferenceLoading(false);
        toast.success('Preferences added successfully');

        // reset the field values
        setSelectedValue('');
        formData.value = '';
      } catch (error) {
        setPreferenceLoading(false);
        toast.error(`${error.response?.data?.message || 'Error adding preference'}`);
        console.error('Error adding preference:', error.response?.data?.message || error.message);
      }
    }
  };

  const handleDeleteMemberType = async () => {
    if (memberTypeId) {
      try {
        setDeleteMemberTypeLoading(true);

        // Send delete request
        await axios.delete(`${API_BASE_URL}/Member/DeleteMemberTypeByParish?id=${memberTypeId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        // Update the state to remove the deleted item
        setOtherPreferenceList((prevList) => prevList.filter((item) => item.id !== memberTypeId));
        // Handle success
        toast.success('Member type deleted successfully');
      } catch (error) {
        // Handle errors
        toast.error(`Error deleting member type: ${error.message}`);
      } finally {
        setDeleteMemberTypeLoading(false);
        handleCloseMenu(); // Close the menu after deletion, whether successful or not
      }
    }
  };

  const handleDeleteDepartmentPreference = async () => {
    if (departmentPreferenceId) {
      try {
        setDeleteDepartmentLoading(true);

        await axios.delete(`${API_BASE_URL}/Parish/DeleteDepartmentByParish?id=${departmentPreferenceId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        // update the state with the deleted
        setDepartmentPreferenceList((prevList) => prevList.filter((item) => item.id !== departmentPreferenceId));
        // display the success
        toast.success('Department deleted succesfully');
      } catch (error) {
        toast.error(`Error deleting departmnet:, ${error.message}`);
      } finally {
        handleCloseDepMenu();
        setDeleteDepartmentLoading(false);
      }
    }
  };

  // use effect hook to grab department preference data
  useEffect(() => {
    // Create a loading state
    let isMounted = true;
    setStatus2(true);

    const fetchDepartmentPreferencesData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Member/GetMemberTypeByParish?Id=${parishId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        // Check if component is still mounted before setting state
        if (isMounted) {
          setOtherPreferenceList(response.data.data);
          setStatus2(false);
        }
      } catch (error) {
        toast.error('Error fetching Preference Data');
        setStatus2(false);
      }
    };

    // Call the fetch function
    fetchDepartmentPreferencesData();

    // Return a cleanup function
    return () => {
      isMounted = false;
    };
  }, [parishId, token]);

  // use effect hook to grab department preference data
  useEffect(() => {
    // Create a loading state
    let isMounted = true;
    setStatus(true);

    const fetchPreferencesData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Parish/GetDepartmentByParish?Id=${parishId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        // Check if component is still mounted before setting state
        if (isMounted) {
          setDepartmentPreferenceList(response.data.data);
          setStatus(false);
        }
      } catch (error) {
        toast.error('Error fetching Preference Data');
        setStatus(false);
      }
    };

    // Call the fetch function
    fetchPreferencesData();

    // Return a cleanup function
    return () => {
      isMounted = false;
    };
  }, [parishId, token]);

  // use effect hook to grab the parish data
  useEffect(() => {
    // Create a loading state
    let isMounted = true;
    setStatus3(true);

    const fetchParishData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Parish/GetParishById?Id=${parishId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        // Check if component is still mounted before setting state
        if (isMounted) {
          setParishData(response.data);
          // console.log(response.data);
          setStatus3(false);
        }
      } catch (error) {
        toast.error('Error fetching Preference Data');
        setStatus3(false);
      }
    };

    // Call the fetch function
    fetchParishData();

    // Return a cleanup function
    return () => {
      isMounted = false;
    };
  }, [parishId, token]);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Settings | CaaS MS</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom>
          Settings
        </Typography>

        <Tabs
          value={selectedTab}
          onChange={handleChangeTab}
          centered={false}
          indicatorColor="secondary"
          textColor="primary"
          variant="scrollable"
          sx={{ mb: { xs: 1, md: 2 } }}
        >
          <Tab label="Accounts" />
          <Tab label="Preferences" />
        </Tabs>
        {selectedTab === 0 && (
          <Card
            style={{
              background: '#fcfcfc',
              borderRadius: '15px',
              boxShadow: '2px 4px 10px 1px rgba(201,201,201,0.47)',
              padding: '20px',
              marginTop: '20px',
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  InputProps={{ readOnly: true }}
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                  value={parishData.name || ''}
                  onChange={(e) => setParishData((prev) => ({ ...prev, name: e.target.value }))}
                  label="Name of Parish"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  InputProps={{ readOnly: true }}
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                  value={parishData.parishEmail || ''}
                  onChange={(e) => setParishData((prev) => ({ ...prev, email: e.target.value }))}
                  label="Email"
                  type="Email"
                  fullWidth
                />
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <input
                  type="file"
                  accept="image/jpeg, image/png"
                  onChange={(e) => setParishData((prev) => ({ ...prev, profilePicture: e.target.files[0] }))}
                />
              </Grid> */}
              <Grid item xs={12} md={6}>
                <TextField
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                  value={parishData.parishPhoneNumber || ''}
                  onChange={(e) => setParishData((prev) => ({ ...prev, parishPhoneNumber: e.target.value }))}
                  label="Phone Number"
                  type="number"
                  name="phoneNumber"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                  value={parishData.address || ''}
                  onChange={(e) => setParishData((prev) => ({ ...prev, address: e.target.value }))}
                  label="Address"
                  type="text"
                  name="address"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                  value={parishData.pastorName || ''}
                  onChange={(e) => setParishData((prev) => ({ ...prev, pastorName: e.target.value }))}
                  label="Pastor-in-Charge/Contact Person"
                  name=""
                  fullWidth
                />
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <TextField
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                  label="Password"
                  type="password"
                  fullWidth
                />
              </Grid> */}
              {/* <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      '&.Mui-focused': {
                        color: '#000080', // Set the focused label color here
                      },
                    }}
                  >
                    Notification Preferences
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Notification Preferences"
                    sx={{
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#000080',
                        },
                        '& .MuiInputLabel-outlined': {
                          color: '#000080',
                        },
                      },
                    }}
                  >
                    <MenuItem value="Calls">Calls</MenuItem>
                    <MenuItem value="Text Messages">Text Messages</MenuItem>
                    <MenuItem value="Email">Email</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={handleSave}
                  sx={{
                    background: '#000080',
                  }}
                >
                  {loading ? 'Saving Changes...' : 'Save Changes'}
                </Button>
              </Grid>
            </Grid>
          </Card>
        )}
        {selectedTab === 1 && (
          <Card
            style={{
              background: '#fcfcfc',
              borderRadius: '15px',
              boxShadow: '2px 4px 10px 1px rgba(201,201,201,0.47)',
              padding: '20px',
              marginTop: '20px',
            }}
          >
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={1}>
              <Typography variant="subtitle1"> </Typography>
              <Button
                onClick={handleOpenDialog}
                size="small"
                sx={{
                  color: '#000080',
                }}
              >
                Add
              </Button>
            </Stack>

            {status && status2 === true ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <CircularProgress size={24} color="inherit" />
              </div>
            ) : otherPreferenceList.length > 0 ? (
              <Stack direction={'row'} gap={5}>
                <Paper sx={{ width: '100%', overflow: 'hidden', flex: 1 }}>
                  <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Member Type</TableCell>
                          <TableCell align="right">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {otherPreferenceList.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="left">{item.name}</TableCell>
                            <TableCell align="right">
                              <IconButton
                                size="large"
                                color="inherit"
                                onClick={(event) => {
                                  handleOpenMenu(event, item.id);
                                }}
                              >
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>

                {/* department preference */}
                <Paper sx={{ width: '100%', overflow: 'hidden', flex: 1 }}>
                  <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Department</TableCell>
                          <TableCell align="right">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {departmentPreferenceList.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="left">{item.departmentName}</TableCell>
                            <TableCell align="right">
                              <IconButton
                                size="large"
                                color="inherit"
                                onClick={(event) => {
                                  handleOpenDepMenu(event, item.id);
                                }}
                              >
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Stack>
            ) : (
              <p style={{ textAlign: 'center', color: 'red', margin: '10px' }}>No preferences available</p>
            )}
          </Card>
        )}

        {/* mebmber type pop over */}
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem disabled={deleteMemberTypeLoading} onClick={handleDeleteMemberType} sx={{ color: 'error.main' }}>
            {deleteMemberTypeLoading ? (
              <>
                <Iconify icon={'material-symbols:remove'} sx={{ mr: 2 }} />
                Removing..
              </>
            ) : (
              <>
                <Iconify icon={'dashicons:remove'} sx={{ mr: 2 }} />
                Remove
              </>
            )}
          </MenuItem>
        </Popover>

        {/* department popover */}
        <Popover
          open={Boolean(openDep)}
          anchorEl={openDep}
          onClose={handleCloseDepMenu}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem
            disabled={deleteDepartmentLoading}
            onClick={handleDeleteDepartmentPreference}
            sx={{ color: 'error.main' }}
          >
            {deleteDepartmentLoading ? (
              <>
                <Iconify icon={'material-symbols:remove'} sx={{ mr: 2 }} />
                Removing..
              </>
            ) : (
              <>
                <Iconify icon={'dashicons:remove'} sx={{ mr: 2 }} />
                Remove
              </>
            )}
          </MenuItem>
        </Popover>
      </Container>

      <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth>
        <DialogTitle>Add a Preference</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{
                '&.Mui-focused': {
                  color: '#000080', // Set the focused label color here
                },
              }}
            >
              Preference Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Preference Type"
              value={selectedValue}
              onChange={(e) => setSelectedValue(e.target.value)}
              sx={{
                '&.Mui-focused': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#000080',
                  },
                  '& .MuiInputLabel-outlined': {
                    color: '#000080',
                  },
                },
              }}
            >
              <MenuItem value="Department">Department</MenuItem>
              <MenuItem value="Member Type">Member Type</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Value"
            type="text"
            value={formData.value}
            name="value"
            onChange={handleChange}
            fullWidth
            sx={{
              mt: 2,
              // change the focus color
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#000080',
              },
              // the label color
              '& .MuiInputLabel-outlined.Mui-focused': {
                color: '#000080',
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{ color: '#000080' }} onClick={handleCloseDialog}>
            Cancel
          </Button>
          <Button disabled={preferenceLoading} sx={{ color: '#000080' }} onClick={handleSavePreference}>
            {preferenceLoading ? <CircularProgress size={24} color="inherit" /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
